import { convertStyle } from 'utils/Style';

import promotionStyle from '../style/Promotion.module.scss';
import missionStyle from '../style/MissionEvent.module.scss';
import { useEffect, useState } from 'react';

const style = { ...promotionStyle, ...missionStyle };



function Notice({txt}){

    const [text, setText] = useState(null);

    useEffect(()=>{
        if(!txt){
            return;
        }
        let tmp = txt.split("\n");
        
        setText([...tmp]);
    },[]);

    if(text === null){
        return false;
    }

    return (
        <div className={convertStyle(style, "notice_box color-bg-02")}>
            <h3 className={convertStyle(style, "title color-txt-04 title-02-b-long")}>
                이벤트 참여시 확인해주세요!
            </h3>
            <ul className={convertStyle(style, "desc")}>
                {text.map((item, index)=>{
                    return (
                        <li key={index} className={convertStyle(style, "color-txt-05 body-04-long")}>
                            {item}
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}




export default Notice;